import React from 'react';
import { useTheme } from '../context/ThemeContext';

interface ThemeToggleProps {
  className?: string;
}

/**
 * Botão circular para alternar entre tema light e dark.
 * Usa a linguagem visual do projeto: glass-panel, primary, material symbols.
 */
export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Mudar para modo claro' : 'Mudar para modo escuro'}
      title={isDark ? 'Modo claro' : 'Modo escuro'}
      className={`
        group relative flex items-center justify-center
        w-9 h-9 rounded-xl
        bg-slate-800/40 hover:bg-slate-800/80
        border border-slate-700/50 hover:border-primary/50
        text-slate-400 hover:text-primary
        transition-all duration-300
        ${className}
      `}
    >
      <span
        key={isDark ? 'moon' : 'sun'}
        className="material-symbols-outlined text-[18px] transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12"
      >
        {isDark ? 'light_mode' : 'dark_mode'}
      </span>
    </button>
  );
};
